module.exports = __webpack_public_path__ + "img/tarot-major-arcana-03.935b468f.png";